import { Box, Chip, useTheme } from '@mui/material';
import { Typography } from '@mui/material';
import { IconButton } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAppDispatch } from '@verantos-dev/core-annotation-tool';
import { Icon } from '@verantos-dev/shared-components';

import { InProgressAnnotationCard } from './InProgressAnnotationCard';

interface NewAnnotationCardProps {
  conceptId: string;
  conflictId: string;
}

export const NewAnnotationCard = ({ conceptId, conflictId }: NewAnnotationCardProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        width: '100%',
        border: `1px solid ${theme.palette.divider}`,
        p: theme.spacing(4),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: theme.spacing(1),
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: '500' }}>
            Supervisor
          </Typography>
          <Chip
            variant="filled"
            sx={{
              backgroundColor: theme.palette.grey[200],
              size: 'small',
              fontSize: '13px',
            }}
            label={formatMessage({ id: 'workspaceCommon.annotationConfig.conceptCard.inProgress' })}
          />
        </Box>
      </Box>
      <InProgressAnnotationCard
        annotation={null}
        conceptId={conceptId}
        conflictId={conflictId || undefined}
      />
    </Box>
  );
};
